import React from 'react';
import { TESTIMONIALS } from '../mock';
import { Star, Quote } from 'lucide-react';

export default function Testimonials() {
  return (
    <section id="reviews" className="relative py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <div className="section-title-eyebrow uppercase">Customer Reviews</div>
          <h2 className="mt-3 text-3xl md:text-5xl font-extrabold">
            <span className="text-white">ગ્રાહકોના </span><span className="gradient-text">અભિપ્રાય</span>
          </h2>
          <p className="mt-4 text-gray-400">વડોદરાના સેંકડો ગ્રાહકો જે One Stop Carz પર ભરોસો મૂકે છે.</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <div key={i} className="card-dark p-6 hover-lift">
              <Quote className="w-6 h-6 text-pink-400/60 mb-3" />
              <p className="text-gray-200 text-sm leading-relaxed">{t.text}</p>
              <div className="flex items-center gap-1 mt-4">
                {[...Array(5)].map((_, s) => <Star key={s} className="w-4 h-4 fill-yellow-400 text-yellow-400" />)}
              </div>
              <div className="mt-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold" style={{background:'linear-gradient(135deg,#a855f7,#ec4899)'}}>{t.initial}</div>
                <div>
                  <div className="text-white font-semibold text-sm">{t.name}</div>
                  <div className="text-xs text-gray-400">{t.car}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
